import { createAction } from '@ngrx/store';

export enum QuoteOptionsActionsTypes {
  Init = '[Quote Configuration Endorsements] Initialised',
}

export const QuoteConfigurationEndorsementsActions = {
  init: createAction(QuoteOptionsActionsTypes.Init),
};
